







































































import axios from 'axios';
export default {
	name: 'detalle',
	inject: ['responsive'],
	props: {
		visible: {
			type: Boolean,
			required: true,
			default: false,
		},
		recordSelected: {
			type: Object,
		},
		tableGranos: {
			type: Boolean,
		},
	},
	data() {
		return {
			show: false,
			imprimiendo: false,
		};
	},
	computed: {},
	watch: {
		visible(v) {
			this.show = !this.show;
		},
	},
	filters: {
		capitalize: function (value) {
			if (!value) return '';
			value = value.toString();
			return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
		},
		numeric: function (value) {
			return new Intl.NumberFormat('de-DE').format(value);
		},
	},
	methods: {
		handleClick(num: number): void {
			this.imprimiendo = true;
			const codcom = num === 1 ? this.recordSelected.codcom1 : this.recordSelected.codcom2;
			const codtal = num === 1 ? this.recordSelected.codtal1 : this.recordSelected.codtal2;
			const numero = num === 1 ? this.recordSelected.numero1 : this.recordSelected.numero2;
			let url = `./api/public/proxy/files?codcom=${codcom}&codtal=${codtal}&numero=${numero}&cooperativa=${this.$store.state.config.cuit}&type=pdf`;
			window.open(url);
			this.imprimiendo = false;
		},
	},
	mounted() {},
};
